export const DashboardVariableType = [
	{ name: "Toggle", value: 0 },
	{ name: "Input", value: 1 },
	{ name: "Dropdown", value: 2 },
	{ name: "Button", value: 3 },
	{ name: "Number", value: 4 }

]

let styleDiv = {justifyContent: "start"};
let styleIcons = {marginRight: "25px", color : "var(--main)"}


export const DashboardVariableDropdownIcon = [
	{
		value: 0,
		text: <i className="fas fa-toggle-on" style={styleIcons}></i>
	},
	{
		value: 4,
		text: <i className="fas fa-dice-six"  style={styleIcons}></i>
	},
	{
		value: 1,
		text: <i className="fas fa-keyboard"  style={styleIcons}></i>
	},
	{
		value: 2,
		text: <i className="fas fa-caret-square-down"  style={styleIcons}></i>
	},
	{
		value: 3,
		text: <i className="fas fa-dot-circle"  style={styleIcons}></i>
	},
]

export function getIconByType (type){
	if (type == null) return
	return DashboardVariableDropdownIcon.find((element) => element.value == type).text;
}

export const DashboardVariableTypeDropdown = [
	{
		value: 0,
		text: <div style={styleDiv}> {getIconByType(0)} Switch Button </div> 
	},
	{
		value: 4,
		text: <div  style={styleDiv} >{getIconByType(4)} Number </div> 
	},
	{
		value: 1,
		text: <div  style={styleDiv}>{getIconByType(1)} Text input </div> 
	},
	{
		value: 2,
		text: <div  style={styleDiv} >{getIconByType(2)} Drop-down list </div> 
	},
	{
		value: 3,
		text: <div  style={styleDiv} >{getIconByType(3)} Button </div> 
	},
]
